import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { getFontSize } from '../utils/getFont';
import { Close } from '../assets/icons';
import { Input } from '../components';

export const Container = styled.div`
  position: fixed;
  bottom: 10%;
  left: 0;
  right: 0;
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;

  > div {
    position: relative;

    background-color: ${({ status }) => (status === 'success' ? 'var(--success-light)' : 'var(--accent-light)')};
    color: ${({ status }) => (status === 'success' ? 'var(--success-dark)' : 'var(--error)')};
    border: 3px solid ${({ status }) => (status === 'success' ? 'var(--success)' : 'var(--error)')};

    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 90%;
    height: 94%;
    max-width: 500px;
    text-align: center;

    display: flex;
    flex-direction: column;
  }

  .emoji {
    ${getFontSize(7)}
  }
`;

export const Alert = ({ code, seconds, title, body, emoji, onClose }) => {
  const [showing, setShowing] = useState(false);
  const [timer, setTimer] = useState(seconds || 3);

  useEffect(() => {
    if (timer > 0) {
      setShowing(true);
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      onClose();
    }
  }, [timer, onClose]);

  return (
    <>
      {showing && (
        <Container status={code < 400 ? 'success' : 'error'}>
          <div>
            <h2>{title}</h2>
            <p>{body}</p>
            <p className="emoji">{emoji}</p>
          </div>
        </Container>
      )}
    </>
  );
};
